module.exports = __webpack_public_path__ + "img/cost-calculator-1.2fd039bb.svg";